import { Link } from "react-router-dom";
import { newsList } from "@/mocks/news";
import { getMediaById, formatViews } from "@/lib/mediaQuery";
import { mediaList } from "@/mocks/media";
import SectionHeading from "@/components/base/SectionHeading";

const hotMedia = [...mediaList].sort((a, b) => b.views - a.views).slice(0, 5);

export default function NewsSection() {
  const news = newsList.slice(0, 8);

  return (
    <section className="w-full bg-background-100 border-y border-background-200">
      <div className="w-full px-4 md:px-6 py-12 md:py-16">
        <SectionHeading
          eyebrow="资讯动态"
          title="最新影视资讯"
          description="第一时间同步影视资讯、幕后揭秘与行业观察，掌握最新的观影风向。"
        />

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 md:gap-8">
          <div className="lg:col-span-2">
            <ul className="bg-background-50 border border-background-200 rounded-lg divide-y divide-background-200 overflow-hidden">
              {news.map((item) => {
                const related = item.relatedId ? getMediaById(item.relatedId) : undefined;
                return (
                  <li key={item.id}>
                    <Link
                      to={related ? `/detail/${related.id}` : "/search"}
                      className="group flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-5 px-4 md:px-6 py-4 hover:bg-primary-50/60 transition-colors"
                    >
                      <div className="flex items-center gap-3 shrink-0 sm:w-40">
                        <span className="px-2 py-0.5 rounded-md bg-secondary-100 text-secondary-900 text-xs whitespace-nowrap">
                          {item.category}
                        </span>
                        <span className="text-xs text-foreground-400 font-label hidden sm:block">{item.date}</span>
                      </div>
                      <div className="min-w-0 flex-1">
                        <h3 className="text-sm md:text-base font-medium text-foreground-900 line-clamp-1 group-hover:text-primary-600 transition-colors">
                          {item.title}
                        </h3>
                        <p className="mt-1 text-xs text-foreground-500 line-clamp-1">{item.excerpt}</p>
                      </div>
                      <i className="ri-arrow-right-s-line text-foreground-300 group-hover:text-primary-500 shrink-0 hidden sm:block"></i>
                    </Link>
                  </li>
                );
              })}
            </ul>
          </div>

          <aside className="space-y-6">
            <div className="bg-background-50 border border-background-200 rounded-lg p-5">
              <h3 className="font-heading text-base font-bold text-foreground-950 mb-4 flex items-center gap-2">
                <i className="ri-fire-fill text-accent-500"></i>
                热门影视榜
              </h3>
              <ol className="space-y-3">
                {hotMedia.map((m, i) => (
                  <li key={m.id}>
                    <Link to={`/detail/${m.id}`} className="group flex items-center gap-3">
                      <span
                        className={`w-6 h-6 rounded-md flex items-center justify-center text-xs font-bold font-label shrink-0 ${
                          i < 3 ? "bg-accent-500 text-foreground-950" : "bg-background-200 text-foreground-500"
                        }`}
                      >
                        {i + 1}
                      </span>
                      <span className="min-w-0 flex-1">
                        <span className="block text-sm text-foreground-800 group-hover:text-primary-600 transition-colors truncate">
                          {m.title}
                        </span>
                        <span className="block text-xs text-foreground-400 font-label">{formatViews(m.views)} 次浏览</span>
                      </span>
                    </Link>
                  </li>
                ))}
              </ol>
            </div>

            <div className="bg-primary-900 rounded-lg p-5 text-background-50">
              <h3 className="font-heading text-base font-bold mb-2">找不到想看的？</h3>
              <p className="text-xs text-background-100/75 leading-relaxed mb-4">
                输入片名、导演或剧情关键词，即可在全站影视库中快速检索。
              </p>
              <Link
                to="/search"
                className="inline-flex items-center gap-1.5 px-4 py-2 rounded-md bg-accent-500 text-foreground-950 text-sm font-medium hover:bg-accent-400 transition-colors whitespace-nowrap"
              >
                <i className="ri-search-line"></i>
                去搜索影视
              </Link>
            </div>
          </aside>
        </div>
      </div>
    </section>
  );
}